<template>
  <div>
    <!-- <v-btn color="info" :disabled="loadingRequests" @click="dialog = true">Filtro avançado</v-btn> -->
    <v-layout row wrap class="ma-0">
      <v-flex xs10 class="ma-0 pa-0">
        <!-- clearable -->
        <v-autocomplete
          v-model="chips"
          :items="itensFiltroAvancado"
          item-text="texto"
          item-value="nomePropriedade"
          label="Opções"
          chips
          hide-selected
          prepend-inner-icon="filter_list"
          color="#ff0d7b"
          solo
          multiple
          flat
          background-color="#cfd8dc"
        >
          <template slot="item" slot-scope="data">
            <v-list-tile-content
              @click="modificaFiltro($event, data.item.nomePropriedade, data.selected)"
            >
              <v-list-tile-title v-html="`${data.item.texto}`"></v-list-tile-title>
            </v-list-tile-content>
          </template>

          <template slot="selection" slot-scope="data">
            <v-chip
              @click="modificaFiltro($event, data.item.nomePropriedade)"
              :selected="data.selected"
              close
              @input="remover(data.item)"
            >
              <strong>{{ data.item.texto }}</strong>&nbsp;
              <span>({{ retornaValorDoFiltro(data.item.nomePropriedade) }})</span>
            </v-chip>
          </template>
        </v-autocomplete>
      </v-flex>

      <v-flex xs1>
        <v-tooltip top>
          <v-switch
            v-model="filtro.pagamentoComExcecao"
            label="exceção"
            slot="activator"
            hide-details
          ></v-switch>
          <span>Filtrar pagamentos aprovados em exceção</span>
        </v-tooltip>
      </v-flex>

      <v-flex xs1 style="text-align: left;" class="mr-0 pr-0">
        <v-btn color="primary" @click="verificarQualFiltroBuscar()" :loading="loadingRequests">
          <span>Filtrar</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialogFormulario" width="30%">
      <v-card>
        <v-card-title>
          <h3 class="headline mb-0">Filtro</h3>
        </v-card-title>
        <v-layout row wrap justify-center v-if="filtroSelecionado == 'status'">
          <v-flex>
            <v-autocomplete
              label="Selecione o Status"
              :items="listaDeStatus"
              item-text="nome"
              item-value="valor"
              v-model="filtro.status"
            >
              <template slot="no-data">
                <div class="noDataSlot">Não encontramos este status</div>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'datas'">
          <v-flex md12 lg12>
            <span class="font-weight-bold">Data de vencimento</span>
            <v-layout row wrap>
              <v-flex md6 lg6>
                <c-seletor-data 
                  @pegarData="(dataInserida) => {
                    gerarDataMaxima(dataInserida, 'vencimento');
                    filtro.dataVencimentoInicio = dataInserida;
                  }"
                  :dataMaxima="filtro.dataVencimentoFim" 
                  nomeDoCampo="Data inicial" 
                  :data="filtro.dataVencimentoInicio"
                  :regras="[]">
                </c-seletor-data>
              </v-flex>
              <v-flex md6 lg6>
                <c-seletor-data
                @pegarData="(dataInserida) => {
                  filtro.dataVencimentoFim = dataInserida
                }"
                :dataMinima="filtro.dataVencimentoInicio"
                nomeDoCampo="Data final"
                :data="filtro.dataVencimentoFim"
                :regras="[]">
                </c-seletor-data>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'dataDeEmissao'">
          <v-flex md12 lg12 v-if="telaAtual != 'PagamentoColaborador'">
            <span class="font-weight-bold">Data de emissão</span>
            <v-layout row wrap>
              <v-flex md6 lg6>
                <c-seletor-data 
                  @pegarData="(dataInserida) => {
                    gerarDataMaxima(dataInserida, 'emissao');
                    filtro.dataEmissaoInicio = dataInserida;
                  }" 
                  nomeDoCampo="Data inicial" 
                  :dataMaxima="diaDeHoje" 
                  :data="filtro.dataEmissaoInicio"
                  :regras="[]">
                </c-seletor-data>
              </v-flex>
              <v-flex md6 lg6>
                <c-seletor-data 
                  @pegarData="(dataInserida) => {
                    filtro.dataEmissaoFim = dataInserida;
                  }"  
                  :regras="[]" 
                  nomeDoCampo="Data final" 
                  :dataMinima="filtro.dataEmissaoInicio" 
                  :dataMaxima="diaDeHoje" 
                  :data="filtro.dataEmissaoFim">
                </c-seletor-data>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'nomeOuCpfOuCnpj'">
          <v-flex>
            <v-text-field
              label="Cpf, Cnpj ou Nome do fornecedor estrangeiro"
              v-model="filtro.nomeOuCpfOuCnpj"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'numeroDoDocumento'">
          <v-flex>
            <v-text-field label="Número Documento" v-model="filtro.numeroDoDocumento"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'empresa'">
          <v-flex>
            <v-autocomplete
              label="Empresa"
              placeholder="Selecione"
              clearable
              :items="empresas.content"
              item-text="nome"
              item-value="id"
              v-model="filtro.idDaEmpresa"
              @input="buscarCentrosDeCustosPorEmpresa(filtro.idDaEmpresa)"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'centroDeCusto'">
          <v-flex>
            <v-autocomplete
              label="Centro de custo"
              placeholder="Selecione"
              clearable
              v-model="filtro.idDoCentroDeCusto"
              :items="centrosDeCustos"
              item-text="nome"
              item-value="id"
              no-data-text="Selecione uma empresa."
              @input="buscarContasGerenciaisPorCentroDeCusto(filtro.idDoCentroDeCusto)"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'contaGerencial'">
          <v-flex>
            <v-autocomplete
              label="Conta gerencial"
              placeholder="Selecione"
              clearable
              v-model="filtro.idDaContaGerencial"
              :items="contasGerenciais"
              no-data-text="Selecione um Centro de Custo."
              item-text="nome"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'formaDePagamento'">
          <v-flex v-if="telaAtual != 'PagamentoColaborador'">
            <v-autocomplete
              label="Forma do pagamento"
              placeholder="Selecione"
              clearable
              v-model="filtro.formaDePagamento"
              :items="formasDePagamento"
              item-text="nome"
              item-value="valor"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'numeroDoPedido'">
          <v-flex xs12>
            <v-text-field
              label="Número do pedido"
              placeholder="Digite um número"
              type="number"
              v-model="filtro.numeroDoPedido"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'solicitante'">
          <v-flex>
            <v-text-field
              label="Solicitante"
              placeholder="Digite um e-mail"
              v-model="filtro.solicitante"
              type="e-mail"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'valorDoPagamento'">
          <v-flex>
            <span class="font-weight-bold">Valor do pagamento</span>
            <v-layout row wrap>
              <v-flex md6 lg6>
                <v-text-field
                  label="Valor inicial"
                  placeholder="Digite um valor"
                  v-model="filtro.valorInicio"
                  @blur="($event) => {
                          filtro.valorInicio = converterParaMoedaReal(
                          converterValorStringEmNumero($event.target.value, 'BRL')
                        )}"
                ></v-text-field>
              </v-flex>
              <v-flex md6 lg6>
                <v-text-field
                  label="Valor final"
                  placeholder="Digite um valor"
                  v-model="filtro.valorFinal"
                  @blur="($event) => {
                          filtro.valorFinal = converterParaMoedaReal(
                          converterValorStringEmNumero($event.target.value, 'BRL')
                        )}"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center v-if="filtroSelecionado == 'pagamentoComExcecao'">
          <v-flex>
            <v-tooltip top>
              <v-switch
                v-model="filtro.pagamentoComExcecao"
                label="Pagamento exceção"
                class="font-weight-bold"
                slot="activator"
                hide-details
              ></v-switch>
              <span>Filtrar pagamentos aprovados em exceção</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-btn @click="removerNoModal()" color="error" dark>Remover</v-btn>

        <v-btn @click="aplicarFiltro()" color="primary" absolute right>Aplicar</v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { bus } from "../../main";
import moedasMixins from "../../mixins/moedasMixin";
import moment from "moment";
import  SeletorData from "../shared/SeletorData";

export default {
  data() {
    return {
      chips: [],
      dialog: false,
      rangeMaximo: {
        vencimento: "",
        emissao: "",
      },
      formasDePagamento: [
        { nome: "Boleto Bancário", valor: "BOLETO" },
        { nome: "Ordem de Pagamento", valor: "ORDEM_DE_PAGAMENTO" },
        { nome: "Depósito Bancário", valor: "DEPÓSITO" },
        { nome: "Câmbio", valor: "CÂMBIO" },
        { nome: "Tributos/Concessionária", valor: "TRIBUTOS" },
        { nome: "Cartão de Crédito", valor: "CARTÃO_DE_CRÉDITO" },
        { nome: "Sispag (Exclusivo DP)", valor: "SISPAG" },
      ],
      centrosDeCustos: [],
      contasGerenciais: [],
      form: false,
      itensFiltroAvancado: [],
      filtroSelecionado: "status",
      dialogFormulario: false,
    };
  },
  props: {
    telaAtual: {
      type: String,
      default: "PagamentoFornecedor",
    },
    filtro: {
      type: Object,
    },
    viewAtual: {
      type: Object,
    },
    page: {
      type: Number,
    },
    ehUsuarioAprovador: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      empresas: (state) => state.empresas,
      loggedUser: (state) => state.loggedUser,
      loadingRequests: (state) => state.loadingRequests,
      listaDeStatus: (state) => state.listaDeStatus,
    }),
    diaDeHoje() {
      return moment().format("YYYY-MM-DD");
    },
  },
  methods: {
    gerarDataMaxima(dataRecebida, nomeVar) {
      let dataParaTratar = moment(dataRecebida);
      this.rangeMaximo[nomeVar] = this.modificarMeses("somar", dataParaTratar);
    },
    validarDatas(dataInicio, dataFim, tipo) {
      let dataParaTratar;
      let contaCorretaPorTipo = tipo == "vencimento" ? "somar" : "subtrair";

      if (dataInicio != "" && dataFim == "") {
        dataParaTratar = moment(dataInicio);

        dataFim = this.modificarMeses("somar", dataParaTratar);
      }

      if (dataInicio == "" && dataFim != "") {
        dataParaTratar = moment(dataFim);

        dataInicio = this.modificarMeses("subtrair", dataParaTratar);
      }

      if (dataInicio == "" && dataFim == "") {
        dataParaTratar = moment();

        if (tipo == "vencimento") {
          dataInicio = dataParaTratar.startOf("month").format("YYYY-MM-DD");
        } else {
          dataFim = dataParaTratar.endOf("month").format("YYYY-MM-DD");
        }

        if (tipo == "vencimento") {
          dataFim = this.modificarMeses(contaCorretaPorTipo, dataParaTratar);
          dataFim = moment(dataFim).startOf("month").format("YYYY-MM-DD");
        } else
          dataInicio = this.modificarMeses(contaCorretaPorTipo, dataParaTratar);
      }

      return [dataInicio, dataFim];
    },
    modificarMeses(tipoDeConta, dataRecebida) {
      dataRecebida = dataRecebida.clone();

      if (tipoDeConta == "somar") dataRecebida = dataRecebida.add(6, "months");
      else dataRecebida = dataRecebida.subtract(6, "months");

      return dataRecebida.format("YYYY-MM-DD");
    },
    formataData(data) {
      if (data == "") return "";
      let [ano, mes, dia] = data.split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    removerNoModal() {
      this.dialogFormulario = false;

      let itemSelecionado = this.chips.filter(
        (i) => i.nomePropriedade == this.filtroSelecionado
      )[0];

      this.remover(itemSelecionado);
    },
    remover(itemPraRemover) {
      if (itemPraRemover.propriedadesFilhas.length > 0) {
        itemPraRemover.propriedadesFilhas.map((i) => {
          if (i == "valorInicio" || i == "valorFinal")
            this.filtro[i] = "R$ 0,00";
          else this.filtro[i] = "";
        });
      } else {
        this.filtro[itemPraRemover.nomePropriedade] = "";
      }

      this.chips.splice(this.chips.indexOf(itemPraRemover), 1);
      this.chips = [...this.chips];
    },
    podeRemoverDoFiltro(item) {
      if (item != "status") return true;
      else return false;
    },
    retornaValorDoFiltro(propriedade) {
      if (propriedade == "datas")
        return `${this.formataData(
          this.filtro.dataVencimentoInicio
        )} - ${this.formataData(this.filtro.dataVencimentoFim)}`;

      if (propriedade == "dataDeEmissao")
        return `${this.formataData(
          this.filtro.dataEmissaoInicio
        )} - ${this.formataData(this.filtro.dataEmissaoFim)}`;

      if (propriedade == "valorDoPagamento")
        return `${this.filtro.valorInicio} - ${this.filtro.valorFinal}`;

      if (propriedade == "status")
        return this.listaDeStatus.filter(
          (i) => i.valor == this.filtro.status
        )[0].nome;

      if (propriedade == "empresa")
        return this.empresas.content.filter(
          (i) => i.id == this.filtro.idDaEmpresa
        )[0].nome;

      if (propriedade == "centroDeCusto") {
        if (this.centrosDeCustos.length > 0)
          return this.centrosDeCustos.filter(
            (c) => c.id == this.filtro.idDoCentroDeCusto
          )[0].nome;
        else return this.filtro.idDoCentroDeCusto;
      }

      if (propriedade == "contaGerencial") {
        if (this.contasGerenciais.length > 0)
          return this.contasGerenciais.filter(
            (c) => c.id == this.filtro.idDaContaGerencial
          )[0].nome;
        else return this.filtro.idDaContaGerencial;
      }

      if (
        propriedade == "formaDePagamento" &&
        this.filtro.formaDePagamento != ""
      )
        return this.formasDePagamento.filter(
          (i) => i.valor == this.filtro.formaDePagamento
        )[0].nome;
      else return this.filtro[propriedade];
    },
    aplicarFiltro() {
      this.dialogFormulario = false;
    },
    modificaFiltro(event, propriedade) {
      event.preventDefault();
      this.dialogFormulario = true;
      this.filtroSelecionado = propriedade;
    },
    async filtrarSolicitacoesDeFornecedor(pagina) {
      this.$store.commit("set", {
        itemName: "loadingRequests",
        content: true,
      });
      let urlFiltro = `/solicitacoes/busca?`;
      let filtroIdUsuarioRegistrador = "idDoUsuarioRegistrador=";
      let filtroIdUsuarioAprovador = "idDoUsuarioAprovador=";
      if (this.viewAtual.nome === "Minhas Solicitações") {
        filtroIdUsuarioRegistrador = `${filtroIdUsuarioRegistrador}${this.loggedUser.id}`;
        this.filtro.idDoUsuarioAprovador = null;
      } else
        filtroIdUsuarioAprovador = `${filtroIdUsuarioAprovador}${this.loggedUser.id}`;

      this.filtro.papeis = this.loggedUser.papeis;

      for (let i in this.filtro) {
        if (this.filtro[i] == undefined) {
          this.filtro[i] = "";
        }
      }

      let vencimentos = this.validarDatas(
        this.filtro.dataVencimentoInicio,
        this.filtro.dataVencimentoFim,
        "vencimento"
      );

      urlFiltro = `${urlFiltro}solicitante=${
        this.filtro.solicitante
      }&${filtroIdUsuarioRegistrador}&${filtroIdUsuarioAprovador}&dataEmissaoInicio=${
        this.filtro.dataEmissaoInicio
      }&dataEmissaoFim=${this.filtro.dataEmissaoFim}&dataVencimentoInicio=${
        this.filtro.dataVencimentoInicio
      }&dataVencimentoFim=${
        this.filtro.dataVencimentoFim
      }&nomeOuCpfOuCnpj=${this.filtro.nomeOuCpfOuCnpj
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "")}&numeroDoDocumento=${
        this.filtro.numeroDoDocumento
      }&numeroDoPedido=${this.filtro.numeroDoPedido}&status=${
        this.filtro.status
      }&empresa=${this.filtro.idDaEmpresa}&centroDeCusto=${
        this.filtro.idDoCentroDeCusto
      }&contaGerencial=${this.filtro.idDaContaGerencial}&formaDePagamento=${
        this.filtro.formaDePagamento
      }&valorInicio=${parseFloat(
        this.converterValorStringEmNumero(this.filtro.valorInicio, "BRL").trim()
      )}&valorFinal=${parseFloat(
        this.converterValorStringEmNumero(this.filtro.valorFinal, "BRL").trim()
      )}&pagamentoComExcecao=${this.filtro.pagamentoComExcecao}&pagina=${
        pagina - 1
      }`;

      localStorage.setItem(
        "camposSolicitacaoFornecedor",
        JSON.stringify(this.filtro)
      );
      await this.fazerRequest(urlFiltro)
        .then((resposta) => {
          resposta.data.content.map((s) => (s.selecionado = false));
          bus.$emit("pedidosFiltrados", resposta.data);
        })
        .catch((e) => {
          bus.$emit("pedidosFiltrados", []);
        });
      this.page = pagina;
      this.dialog = false;
    },
    async filtarPedidosDeColaborador() {
      this.$store.commit("set", {
        itemName: "loadingRequests",
        content: true,
      });
      let urlFiltro = "/pedidos/busca?";
      let filtroIdUsuarioAprovador = "idDoUsuarioAprovador=";
      let filtroIdUsuarioRegistrador = "idDoUsuarioRegistrador=";
      if (
        this.ehUsuarioAprovador &&
        this.viewAtual.nome === "Solicitações dos Usuários"
      ) {
        filtroIdUsuarioAprovador = `${filtroIdUsuarioAprovador}${this.loggedUser.id}`;
      } else {
        filtroIdUsuarioRegistrador = `${filtroIdUsuarioRegistrador}${this.loggedUser.id}`;
      }
      for (let i in this.filtro) {
        if (this.filtro[i] == undefined) {
          this.filtro[i] = "";
        }
      }

      // let vencimentos = this.validarDatas(
      //   this.filtro.dataVencimentoInicio,
      //   this.filtro.dataVencimentoFim,
      //   "vencimento"
      // );

      urlFiltro = `${urlFiltro}${filtroIdUsuarioAprovador}&${filtroIdUsuarioRegistrador}&status=${
        this.filtro.status
      }&empresa=${this.filtro.idDaEmpresa}&numeroDoPedido=${
        this.filtro.numeroDoPedido
      }&centroDeCusto=${this.filtro.idDoCentroDeCusto}&contaGerencial=${
        this.filtro.idDaContaGerencial
      }&solicitante=${this.filtro.solicitante}&dataVencimentoInicio=${
        this.filtro.dataVencimentoInicio
      }&dataVencimentoFim=${
        this.filtro.dataVencimentoFim
      }&valorInicio=${parseFloat(
        this.converterValorStringEmNumero(this.filtro.valorInicio, "BRL").trim()
      )}&valorFinal=${parseFloat(
        this.converterValorStringEmNumero(this.filtro.valorFinal, "BRL").trim()
      )}&nomeOuCpfOuCnpj=${this.filtro.nomeOuCpfOuCnpj
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "")}&pagamentoComExcecao=${
        this.filtro.pagamentoComExcecao
      }&pagina=0`;

      localStorage.setItem(
        "camposSolicitacaoPedidos",
        JSON.stringify(this.filtro)
      );
      await this.fazerRequest(urlFiltro)
        .then((resposta) => {
          resposta.data.content.map((p) => (p.selecionado = false));
          bus.$emit("reembolsosFiltrados", resposta.data);
        })
        .catch((e) => {
          bus.$emit("reembolsosFiltrados", []);
        });
      this.dialog = false;
    },
    async fazerRequest(url) {
      return await axios({
        method: "get",
        url: `${url}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.loggedUser.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then(function (response) {
          return response;
        })
        .finally((s) => {
          this.$store.commit("set", {
            itemName: "loadingRequests",
            content: false,
          });
        });
    },
    verificarQualFiltroBuscar() {
      if (this.telaAtual == "PagamentoColaborador") {
        this.filtarPedidosDeColaborador();
      } else {
        this.filtrarSolicitacoesDeFornecedor(1);
      }
    },
    buscarCentrosDeCustosPorEmpresa(idDaEmpresa) {
      if (idDaEmpresa == undefined) {
        this.filtro.centroDeCusto = "";
        this.filtro.contaGerencial = "";
        this.centrosDeCustos = [];
        this.contasGerenciais = [];
      } else {
        this.fazerRequest(`/centrosdecustos/empresas/${idDaEmpresa}`)
          .then((resposta) => {
            this.centrosDeCustos = resposta.data;
          })
          .catch((e) => console.log(e));
      }
    },
    buscarContasGerenciaisPorCentroDeCusto(idCentroDeCusto) {
      if (idCentroDeCusto == undefined) {
        this.filtro.idDaContaGerencial = "";
        this.contasGerenciais = [];
      } else {
        this.fazerRequest(`/contasgerenciais/centrodecustos/${idCentroDeCusto}`)
          .then((resposta) => {
            this.contasGerenciais = resposta.data;
          })
          .catch((e) => console.log(e));
      }
    },
    montarFiltroComStorage() {
      let itemParaPegar = "camposSolicitacaoFornecedor";
      if (this.telaAtual == "PagamentoColaborador")
        itemParaPegar = "camposSolicitacaoPedidos";

      let filtroStorage = JSON.parse(localStorage.getItem(itemParaPegar));
      Object.assign(this.filtro, filtroStorage);

      Object.keys(this.filtro).map((i) => {
        if (this.filtro[i] != "" && this.filtro[i] != "R$ 0,00") {
          this.itensFiltroAvancado.map((f) => {
            let temPropriedade;
            if (f.propriedadesFilhas.length == 0)
              temPropriedade = f.nomePropriedade.indexOf(i);
            else temPropriedade = f.propriedadesFilhas.indexOf(i);

            if (temPropriedade > -1 && this.chips.indexOf(f) == -1) {
              this.chips.push(f);
            }
          });
        }
      });

      this.verificarQualFiltroBuscar();
    },
  },
  mixins: [moedasMixins],
  async created() {
    await this.$store.dispatch("get", {
      loaderName: "loadingCompanies",
      service: "/empresas",
      itemName: "empresas",
    });

    this.itensFiltroAvancado = [
      {
        texto: "Vencimento",
        nomePropriedade: "datas",
        propriedadesFilhas: ["dataVencimentoInicio", "dataVencimentoFim"],
      },
      {
        texto: "Empresa",
        nomePropriedade: "empresa",
        propriedadesFilhas: ["idDaEmpresa"],
      },
      { texto: "Status", nomePropriedade: "status", propriedadesFilhas: [] },
      {
        texto: "Centro de Custo",
        nomePropriedade: "centroDeCusto",
        propriedadesFilhas: ["idDoCentroDeCusto"],
      },
      {
        texto: "Conta Gerencial",
        nomePropriedade: "contaGerencial",
        propriedadesFilhas: ["idDaContaGerencial"],
      },
      {
        texto: "Solicitante",
        nomePropriedade: "solicitante",
        propriedadesFilhas: [],
      },
      {
        texto: "Número do Pedido",
        nomePropriedade: "numeroDoPedido",
        propriedadesFilhas: [],
      },
      {
        texto: "Fornecedor",
        nomePropriedade: "nomeOuCpfOuCnpj",
        propriedadesFilhas: [],
      },
      {
        texto: "Valor do Pagamento",
        nomePropriedade: "valorDoPagamento",
        propriedadesFilhas: ["valorInicio", "valorFinal"],
      },
    ];

    if (this.telaAtual == "PagamentoFornecedor") {
      let filtrosDeFornecedor = [
        {
          texto: "Emissão",
          nomePropriedade: "dataDeEmissao",
          propriedadesFilhas: ["dataEmissaoInicio", "dataEmissaoFim"],
        },
        {
          texto: "Forma de Pagamento",
          nomePropriedade: "formaDePagamento",
          propriedadesFilhas: [],
        },
        {
          texto: "Número Documento",
          nomePropriedade: "numeroDoDocumento",
          propriedadesFilhas: [],
        },
      ];

      this.itensFiltroAvancado = [
        ...this.itensFiltroAvancado,
        ...filtrosDeFornecedor,
      ];
    }

    let temSalvado = localStorage.hasOwnProperty("camposSolicitacaoFornecedor");
    if (temSalvado) {
      await this.montarFiltroComStorage();
    } else {
      await this.verificarQualFiltroBuscar();
    }

    if (this.filtro.idDaEmpresa) {
      this.buscarCentrosDeCustosPorEmpresa(this.filtro.idDaEmpresa);
    }
    if (this.filtro.idDoCentroDeCusto) {
      this.buscarContasGerenciaisPorCentroDeCusto(
        this.filtro.idDoCentroDeCusto
      );
    }

    bus.$on("carregarDados", (pagina) => {
      this.verificarQualFiltroBuscar();
    });
  },
  beforeDestroy() {
    bus.$off("carregarDados");
  },
  components: {
    "c-seletor-data": SeletorData
  }
};
</script>

<style>
</style>